module.exports = __webpack_public_path__ + "11945ecf5dc8bb6ee9606378a69f3227.png";